import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "environments/environment";
import { CreditState } from "../credit-state.interface";
import { RootState } from "../../product/product.store";
import {InitInterface} from "../../../interfaces/credit/init.interface";

export const initCreditThunk = createAsyncThunk<InitInterface>(
    'credits/initCredit',
    async (_, { getState }) => {
        const state = getState() as RootState;

        const result = await axios.post<InitInterface>(`${environment.urls.credits.init}`, {
            productId: state.credit.productId
        });
        return result.data;
    }
);
